<template>
    <div>
        <el-dialog :title="'Edit Product #' + selectedPhoneNumberToUpdate" :visible.sync="dialogChangePrice" :close-on-click-modal="false" :before-close="done => { clear(); done() }">
            <el-dialog title="Add Country" :visible.sync="dialogFormVisible" append-to-body>
                <el-form ref="form" label-width="120px">
                    <el-form-item label="Countries" label-width="120px">
                        <template>
                            <el-select
                                style="width: 70%;"
                                v-model="country"
                                @change="handleChangeSelectedCountry"
                                multiple
                                filterable
                                placeholder="Select Country"
                            >
                                <el-option
                                    v-for="(item, idx) in countries"
                                    :key="idx"
                                    :label="item.countryNameEn"
                                    :value="item.countryNameEn"
                                >
                                    <div>
                                        <span style="margin-right: 5px;">
                                            <country-flag :country='`${item.countryCode.toLowerCase()}`' size='small'/>
                                        </span>
                                        <span style="font-size: 12px">
                                            {{ item.countryNameEn + ` (+${item.countryCallingCode})` }}
                                        </span>
                                    </div>
                                </el-option>
                            </el-select>
                        </template>
                    </el-form-item>
                        <el-table
                            ref="multipleTable"
                            :data="tableData"
                            style="width: 100%; margin-bottom: 20px;"
                            @selection-change="handleSelectionChange"
                        >
                            <el-table-column
                                type="selection"
                                width="55"
                            >
                            </el-table-column>
                            <el-table-column
                                label="Code Prefix"
                                width="120"
                            >
                                <template slot-scope="scope">
                                    {{ '+'+scope.row.countryCallingCode }}
                                </template>
                            </el-table-column>
                            <el-table-column
                                property="countryName"
                                label="Country Name"
                                show-overflow-tooltip
                            >
                                <template slot-scope="scope">
                                    {{ scope.row.countryNameEn }}
                                </template>
                            </el-table-column>
                        </el-table>
                    <el-form-item>
                        <el-button @click="toggleSelection()">Reset</el-button>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="handleChangePrefix(multipleSelection)" :loading="loadingBtn">Submit</el-button>
                <el-button @click="dialogFormVisible=false">Cancel</el-button>
                </span>
            </el-dialog>
            <el-form label-position="top">
                <el-form-item label="Phone Number" label-width="120px">
                    <el-input type="text" v-model="selectedPhoneNumberToUpdate" disabled class="mt-10" />
                </el-form-item>

                <el-form-item v-if="selectedProductToUpdate != '' && selectedProductType!=='wtb_hybrid'" label="FBBM ID" label-width="120px">
					<el-input v-model="selectedProductObject.fbbm_id"></el-input>
				</el-form-item>
                
                <el-form-item label="Product SKU" label-width="120px">
                    <el-select
                    filterable @change="handleChangeSelectedProduct"
                    v-model="selectedProductToUpdate" placeholder="Select product" style="width:100%;" class="mt-10">
                        <el-option
                            v-for="(prd) in product[selectedEditNumber].product" :key="prd._id"
                            :label="prd.productSKU + ` (${formatPrice(prd.price)})`"
                            :value="prd._id">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item v-if="selectedProductType==='wtb_hybrid'" label="Market Prefix Area" label-width="120px">
                    <el-button
                        type="primary"
                        :loading="loadingBtnDelete"
                        @click="dialogMarketPrefixArea=true"
                    >
                        Select Area
                    </el-button><br/>
                    <label>{{`${selectedMarketPrefix ? selectedMarketPrefix.length : '0'} Market and ${marketPrefixLength.length} prefix selected`}}</label>
                </el-form-item>

                <el-form-item v-if="selectedProductType==='wtb_hybrid'" label="Market Quota" label-width="120px">
                    <el-button
                        type="primary"
                        :loading="loadingBtnDelete"
                        @click="configQuota()"
                    >
                        Config Quota
                    </el-button><br/>
                    <label>{{`${selectedMarketPrefix.length} Markets have already been setup as active`}}</label>
                </el-form-item>
                
                <el-form-item v-if="selectedProductType==='wtb_hybrid'" label="WABA ID" label-width="120px">
                    <el-input class="mt-10" @keypress.native="numberOnly" v-model="fbbmId" placeholder="Insert WABA ID"></el-input>
                </el-form-item>
                
                <el-form-item v-if="selectedProductType==='wtb_hybrid'" label="Catalog ID" label-width="120px">
                    <el-input class="mt-10" @keypress.native="numberOnly" v-model="catalogId" placeholder="Insert Catalog ID"></el-input>
                </el-form-item>

                <el-form-item label="Sheet pricing" label-width="120px" v-if="selectedProductObject.type.toLowerCase().indexOf('notification') != -1 && !hidden">
                    <el-input v-model="selectedProductObject.priceSheet" placeholder="Selected sheet. Leave empty for default price." class="mt-10"></el-input>
                    <small>Note: Sheet pricing is refering to this document: <a href="https://docs.google.com/spreadsheets/d/1T459mq-8IxHjmZ2-vxOcrx72gAzKLsAcqcuA591V4TU/" target="_blank">Whatsapp Notification Tiering</a> </small>
                </el-form-item>
                
                <el-form-item label="Allowed prefix" label-width="120px" v-if="selectedProductToUpdate && !hidden && selectedProductType!=='wtb_hybrid'">
                    <el-input v-model="selectedProductObject.allowed_prefix" placeholder="Insert allowed prefix, separate with comma(s). Leave empty for default (allow all prefix)" class="mt-10"></el-input>
                </el-form-item>
                
                <el-form-item v-if="hidden && selectedProductObject.productName != 'Maintenance'" label="Allowed Prefix" label-width="120px">
					<!-- <template>
						<el-select disabled @change="handleChangePrefix" multiple v-model="selectedProductObject.allowedPrefix" filterable placeholder="Select Prefix">
							<el-option
                            v-for="(item) in countries" :key="item.countryCode"
                            :label="item.countryName"
                            :value="'+'+item.prefixCode">
                            <div>
                                <span style="margin-right: 5px;"><country-flag :country='`${item.countryCode.toLowerCase()}`' size='small'/></span>
                                <span style="font-size: 12px">{{ item.countryName + ` (+${item.prefixCode})` }}</span>
                            </div>
                            </el-option>
						</el-select>
					</template> -->
                    <el-button @click="clickPrefix()">Select Prefix</el-button>
                    <span style="margin-left: 1em;"><b>{{selectedProductObject.prefix.length}}</b> Prefix selected</span>
				</el-form-item>

                <el-form-item v-if="hidden && discount && selectedProductObject.productName != 'Maintenance'" label="Discount :" label-width="120px">
					<span v-for="(obj) in selectedProductObject.prefix" :key="obj.code_prefix">
					<el-form v-if="obj.discount" label-width="50px" :model="obj.discount">
						<el-form-item label="CBP">
							<el-row>
								<el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
									<el-select v-model="obj.discount.cbp.type" placeholder="Select Type">
										<el-option
										v-for="(it,i) in discountType"
										:key="i"
										:label="it.label"
										:value="it.value">
										</el-option>
									</el-select>
								</el-col>
								<el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
									<el-input  @keypress.native="numberOnly" @paste.native="paste($event, index, 'cbp_disc')" v-model="obj.discount.cbp.value"></el-input>
								</el-col>
								<el-col style="text-align: center;" :xs="24" :sm="24" :md="4" :lg="4" :xl="4">
									<span>{{totalAfterDisc(obj.discount.cbp.type, obj.price.cbp,obj.discount.cbp.value)}}</span>
								</el-col>
							</el-row>
						</el-form-item>
						<el-form-item label="UI">
							<el-row>
								<el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
									<el-select v-model="obj.discount.ui.type" placeholder="Select Type">
										<el-option
										v-for="(it,i) in discountType"
										:key="i"
										:label="it.label"
										:value="it.value">
										</el-option>
									</el-select>
								</el-col>
								<el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
									<el-input  @keypress.native="numberOnly" @paste.native="paste($event, index, 'ui_disc')" v-model="obj.discount.ui.value"></el-input>
								</el-col>
								<el-col style="text-align: center;" :xs="24" :sm="24" :md="4" :lg="4" :xl="4">
									<span>{{totalAfterDisc(obj.discount.ui.type, obj.price.ui,obj.discount.ui.value)}}</span>
								</el-col>
							</el-row>
						</el-form-item>
						<el-form-item label="BI">
							<el-row>
								<el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
									<el-select v-model="obj.discount.bi.type" placeholder="Select Type">
										<el-option
										v-for="(it,i) in discountType"
										:key="i"
										:label="it.label"
										:value="it.value">
										</el-option>
									</el-select>
								</el-col>
								<el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
									<el-input  @keypress.native="numberOnly" @paste.native="paste($event, index, 'bi_disc')" v-model="obj.discount.bi.value"></el-input>
								</el-col>
								<el-col style="text-align: center;" :xs="24" :sm="24" :md="4" :lg="4" :xl="4">
									<span>{{totalAfterDisc(obj.discount.bi.type, obj.price.bi,obj.discount.bi.value)}}</span>
								</el-col>
							</el-row>
						</el-form-item>
					</el-form>
					</span>
				</el-form-item>

                <el-form-item label="Product Price" label-width="120px" v-if="selectedProductToUpdate && !hidden">
                    <el-input v-model="selectedProductObject.price" placeholder="Insert new price" class="mt-10"></el-input>
                </el-form-item>

                <el-form-item label="Product Minimum Price" label-width="120px" v-if="selectedProductToUpdate && !hidden && selectedProductType!=='wtb_hybrid'">
                    <el-input v-model="selectedProductObject.minPrice" placeholder="Insert new minimum price" class="mt-10"></el-input>
                </el-form-item>
                <el-form-item v-if="hidden" label="Monthly Fee" label-width="120px">
					<el-input v-model="selectedProductObject.minPrice"></el-input>
				</el-form-item>

                <el-form-item v-if="hidden" label="Product Service" label-width="120px">
                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
							<span>Fee</span>
						</el-col>
						<el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
							<!-- <span>Fee</span> -->
							<!-- <el-input disabled v-model="selectedProductObject.product_service.type"></el-input> -->
                            <el-select @change="handleChangeServiceType" v-model="selectedProductObject.product_service.type" placeholder="Select Type">
                                <el-option
                                v-for="(it,i) in discountType"
                                :key="i"
                                :label="it.label"
                                :value="it.value">
                                </el-option>
                            </el-select>
						</el-col>
						<el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
							<!-- <span>UI Limit per Month</span> -->
							<el-input  @keypress.native="numberOnly" @paste.native="paste($event, index, 'service')" v-model="selectedProductObject.product_service.fee" :maxlength="selectedProductObject.product_service.type == 'percentage' ? 2 : 12"></el-input>
						</el-col>
					</el-row>
					<!-- <el-form label-width="100px" :model="selectedProductObject.product_service">
						<el-form-item label="Service Type">
							<el-input disabled v-model="selectedProductObject.product_service.type"></el-input>
						</el-form-item>
						<div><p><span style="font-weight: bold;">Note: </span>Service Fee x Usage(CBP,BI,UI)</p></div>
						<el-form-item label="Service Fee">
							<el-input  @keypress.native="numberOnly" @paste.native="paste($event, index, 'service')" v-model="selectedProductObject.product_service.fee" maxlength="2"></el-input>
						</el-form-item>
					</el-form> -->
				</el-form-item>

                <el-form-item label="Product Free Charge Count" label-width="120px" v-if="selectedProductToUpdate && !hidden && selectedProductType!=='wtb_hybrid'">
                    <el-input v-model="selectedProductObject.count" placeholder="Insert new free charge count" class="mt-10"></el-input>
                </el-form-item>

                <el-form-item label="Product Service Type" label-width="120px" v-if="selectedProductToUpdate && selectedProductObject.type == 'notification' && !hidden">
                    <el-select
                    filterable
                    v-model="selectedProductObject.serviceType" placeholder="Select Product Type" style="width:100%;" class="mt-10">
                        <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="Product Service Type" label-width="120px" v-if="selectedProductToUpdate!='' && !hidden && selectedProductType!=='wtb_hybrid'">
                    <el-input v-model="selectedProductObject.serviceType" class="mt-10" disabled></el-input>
                </el-form-item>

                <el-form-item label="Monthly Free Count" label-width="120px" v-if="selectedProductToUpdate!='' && selectedProductObject.type=='notification_caping_plafon' && !hidden">
                    <el-input v-model="selectedProductObject.monthly_free_count" class="mt-10"></el-input>
                </el-form-item>

                <el-form-item label="Product Service Fee" label-width="120px" v-if="selectedProductToUpdate!='' && !hidden && selectedProductType!=='wtb_hybrid'">
                    <el-input v-model="selectedProductObject.serviceFee" placeholder="Insert new Product Service Fee" class="mt-10"></el-input>
                </el-form-item>

                <el-form-item label="Tier Pricing" label-width="120px" v-if="selectedProductObject.type.indexOf('tier') != -1 && !hidden" >
					<el-row style="margin-bottom: 10px;">
						<el-col :span="6" :md="6" :sm="6" :xs="6" style="margin-right: 8px"><span>From</span></el-col>
						<el-col :span="6" :md="6" :sm="6" :xs="6" style="margin-right: 8px"><span>To</span></el-col>
						<el-col :span="6" :md="6" :sm="6" :xs="6" style="margin-right: 8px"><span>Price</span></el-col>
					</el-row>
					<el-row v-for="(t, index) in selectedProductObject.tier" :key="index" style="margin-bottom: 10px;">
						<el-col :span="6" :md="6" :sm="6" :xs="6" style="margin-right: 8px">
							<el-input v-model="t.from" />
						</el-col>
						<el-col :span="6" :md="6" :sm="6" :xs="6" style="margin-right: 8px">
							<el-input v-model="t.to" />
						</el-col>
						<el-col :span="6" :md="6" :sm="6" :xs="6" style="margin-right: 8px">
							<el-input @keypress.native="numberOnly" @paste.native="paste($event, index, 'price')" v-model="t.price" />
						</el-col>
						<el-col :span="4" :md="4" :sm="4" :xs="4" style="margin-right: 8px">
							<el-button type="text" @click="deleteTier(index)" style="color: red"><i class="mdi mdi-close" /></el-button>
						</el-col>
					</el-row>
					<el-button size="mini" @click="buttonAddTier" type="primary"><i class="mdi mdi-plus"/> Add Tier</el-button>
				</el-form-item>
                <el-form-item v-if="hidden && selectedProductObject.type && selectedProductObject.productName != 'Maintenance'" label="National Quota Prefix Indonesia (Finance)" label-width="120px">
					<el-row>
						<el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
							<span>CBP Limit per Month</span>
							<el-input size="small"  placeholder="Leave empty for '0'" v-model="selectedProductObject.count" disabled ></el-input>
						</el-col>
						<el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
							<span>UI Limit per Month</span>
                            <el-input size="small"  placeholder="Leave empty for '0'" v-model="selectedProductObject.count_ui" disabled ></el-input>
						</el-col>
						<el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
							<span>BI Limit per Month</span>
                            <el-input size="small"  placeholder="Leave empty for '0'" v-model="selectedProductObject.count_bi" disabled ></el-input>
						</el-col>
					</el-row>
				</el-form-item>

                <el-form-item v-if="hidden && selectedProductObject.type && selectedProductObject.productName != 'Maintenance'" label="National Prefix Limit per Month" label-width="120px">
					<el-row>
						<el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
							<span>CBP</span>
                            <!-- <el-input v-if="radio_cbp_max == '2'" size="small" :value="selectedProductObject.monthly_free_count" disabled></el-input> -->
							<el-input size="small" @keypress.native="numberOnly"  @paste.native="paste($event, index, 'cbp')" placeholder="Leave empty for '0'" v-model="selectedProductObject.monthly_free_count" :disabled="selectedProductObject.type == 'notification_caping_plafon' ? false:true"></el-input>
						</el-col>
						<el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
							<span>UI</span>
                            <el-input v-if="ui_max" size="small" value="MAX" disabled></el-input>
							<el-input v-else size="small" @keypress.native="numberOnly"  @paste.native="paste($event, index, 'ui')" placeholder="Leave empty for '0'" v-model="selectedProductObject.monthly_free_count_ui" :disabled="selectedProductObject.type == 'notification_caping_plafon' ? false:true"></el-input>
                            <el-checkbox v-if="selectedProductObject.type == 'notification_caping_plafon'" @change="handleMax" v-model="isMax.ui">MAX</el-checkbox>
						</el-col>
						<el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
							<span>BI</span>
                            <el-input v-if="bi_max" size="small" value="MAX" disabled></el-input>
							<el-input v-else size="small" @keypress.native="numberOnly"  @paste.native="paste($event, index, 'bi')" placeholder="Leave empty for '0'" v-model="selectedProductObject.monthly_free_count_bi" :disabled="selectedProductObject.type == 'notification_caping_plafon' ? false:true"></el-input>
                            <el-checkbox v-if="selectedProductObject.type == 'notification_caping_plafon'" @change="handleMax" v-model="isMax.bi">MAX</el-checkbox>
						</el-col>
					</el-row>
				</el-form-item>
                <el-form-item v-if="hidden && selectedProductObject.type == 'notification_caping_plafon'" label-width="120px">
					<el-row>
						<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
							<span style="font-weight: bold;">Do you want to use CBP quota limit and top up CBP for Transaction Traffic?</span>
                            <div><el-radio v-model="radio_cbp_max" label="1">[YES] - Still use quota limit and top up CBP for Transaction Traffic!</el-radio></div>
                            <div><el-radio v-model="radio_cbp_max" label="2">[NO] - Don’t use quota limit and topup CBP for Transaction Traffic!</el-radio></div>
						</el-col>
					</el-row>
				</el-form-item>
				
				<el-form-item v-if="hidden && selectedProductObject.type == 'notification_caping_plafon' && selectedProductObject.productName != 'Maintenance'" label="Hybrid Type" label-width="120px">
						<el-radio-group v-model="hybrid_type">
							<el-radio :label="1">Bundle Quota</el-radio>
							<el-radio :label="2">Plafon Quota</el-radio>
						</el-radio-group>
				</el-form-item>

                <el-form-item v-if="hidden && selectedProductObject.type == 'notification_caping_plafon' && selectedProductObject.productName != 'Maintenance'" label="Bundle Quota Prefix Indonesia (Field for billing reduction)" label-width="120px">
					<el-row>
						<el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
							<span>CBP</span>
							<el-input size="small"  placeholder="Leave empty for '0'" v-model="selectedProductObject.cbp_bundle" :disabled="hybrid_type == 2" ></el-input>
						</el-col>
						<el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
							<span>UI</span>
                            <el-input size="small"  placeholder="Leave empty for '0'" v-model="selectedProductObject.ui_bundle" :disabled="hybrid_type == 2" ></el-input>
						</el-col>
						<el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
							<span>BI</span>
                            <el-input size="small"  placeholder="Leave empty for '0'" v-model="selectedProductObject.bi_bundle" :disabled="hybrid_type == 2" ></el-input>
						</el-col>
					</el-row>
				</el-form-item>

                <el-form-item v-if="hidden && selectedProductObject.productName != 'Maintenance'" label="International Prefix Limit per Month" label-width="120px">
					<el-row>
						<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
							<span>CBP</span>
                            <el-input v-if="intern_max" size="small" value="MAX" disabled></el-input>
							<el-input v-else @keypress.native="numberOnly"  @paste.native="paste($event, index, 'intern')" size="small" placeholder="Leave empty for 0" v-model="selectedProductObject.monthly_free_count_international" :disabled="selectedProductObject.type != 'notification_caping_plafon' ? true:false"></el-input>
						</el-col>
					</el-row>
				</el-form-item>

                <el-form-item label="Reff Note" label-width="120px" v-if="selectedProductToUpdate!='' && selectedProductType!=='wtb_hybrid'">
                    <el-input type="textarea" :rows="4" v-model="selectedProductObject.reff_note" placeholder="Insert note for updated product (Optional)" class="mt-10"></el-input>
                </el-form-item>

                <el-form-item label="Remark" label-width="120px" v-if="selectedProductType==='wtb_hybrid'">
                    <el-input v-model="editProduct.remark" type="textarea" :rows="4" class="mt-10"></el-input>
                </el-form-item>

                <el-button type="primary" @click="saveUpdateProductPrice" :loading="loadingBtn">Save</el-button>
                <el-button @click="dialogChangePrice = false">Cancel</el-button>
            </el-form>
        </el-dialog>

        <el-dialog :title="'Edit Product #' + selectedPhoneNumberToUpdate" :visible.sync="dialogEditChangePrice" :close-on-click-modal="false" :before-close="done => { clear(); done() }">
            <el-form label-position="top">
                <el-form-item label="Phone Number" label-width="120px">
                    <el-input type="text" v-model="selectedPhoneNumberToUpdate" disabled class="mt-10" />
                </el-form-item>
                
                <el-form-item label="Product SKU" label-width="120px">
                    <el-select
                    filterable @change="handleChangeSelectedProduct"
                    v-model="selectedProductToUpdate" placeholder="Select product" style="width:100%;" class="mt-10">
                        <el-option
                            v-for="(prd) in product[selectedEditNumber].product" :key="prd._id"
                            :label="prd.productSKU + ` (${formatPrice(prd.price)})`"
                            :value="prd._id">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item v-if="selectedProductType==='wtb_hybrid'" label="Market Prefix Area" label-width="120px">
                    <el-button
                        type="primary"
                        :loading="loadingBtnDelete"
                        @click="dialogMarketPrefixArea=true"
                    >
                        Select Area
                    </el-button><br/>
                    <label>{{`${selectedMarketPrefix ? selectedMarketPrefix.length : '0'} Market and ${marketPrefixLength.length} prefix selected`}}</label>
                </el-form-item>

                <el-form-item v-if="selectedProductType==='wtb_hybrid'" label="Market Quota" label-width="120px">
                    <el-button
                        type="primary"
                        :loading="loadingBtnDelete"
                        @click="configQuota()"
                    >
                        Config Quota
                    </el-button><br/>
                    <label>{{`${marketActive.length} Markets have already been setup as active`}}</label>
                </el-form-item>
                
                <el-form-item v-if="selectedProductType==='wtb_hybrid'" label="WABA ID" label-width="120px">
                    <el-input class="mt-10" @keypress.native="numberOnly" v-model="fbbmId" placeholder="Insert FBBM ID"></el-input>
                </el-form-item>
                
                <el-form-item v-if="selectedProductType==='wtb_hybrid'" label="Catalog ID" label-width="120px">
                    <el-input class="mt-10" @keypress.native="numberOnly" v-model="catalogId" placeholder="Insert Catalog ID"></el-input>
                </el-form-item>

                <el-form-item label="Document">
                    <el-upload
                        class="upload-demo"
                        id="inputMedia"
                        :http-request="renderMedia"
                        action=""
                        drag
                        list-type="text"
                        :limit="1"
                    >
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text" @click="renderMedia"
                            >Drop file here or <em>click to upload</em>
                        </div>
                        <div class="el-upload__tip" slot="tip">
                            <b>The maximum file upload size is 100 MB</b>
                        </div>
                    </el-upload>
                </el-form-item>

                <el-form-item label="Product Price" label-width="120px">
                    <el-input @keypress.native="numberOnly" v-model="editProduct.price" placeholder="Insert new price" class="mt-10"></el-input>
                </el-form-item>

                <el-form-item label="Tax" label-width="120px">
                    <el-input :value="selectedProductObject.tax" type="text" disabled class="mt-10" />
                </el-form-item>

                <el-form-item label="Remark" label-width="120px">
                    <el-input v-model="editProduct.remark" type="textarea" :rows="4" class="mt-10"></el-input>
                </el-form-item>

                <el-button @click="addEditProduct()" type="primary" :loading="btnLoadingAddChangePrice">Save</el-button>
                <el-button @click="dialogEditChangePrice = false">Cancel</el-button>
            </el-form>
        </el-dialog>

        <el-dialog title="Market Prefix Area" :visible.sync="dialogMarketPrefixArea" width="50%">
            <el-form>
                <el-row
                    :gutter="12"
                    v-for="(item, idx) in selectedMarketPrefix"
                >
                    <el-card class="mb-10">
                        <el-col :span="2" :xs="22" :sm="22" :md="22" :lg="11" :xl="11">
                            <label>
                                Market Name
                            </label>
                            <el-form-item>
                                <el-select
                                    v-model="selectedMarketPrefix[idx].master_market_area_code"
                                    style="width:100%;"
                                    placeholder="Market Name"
                                    @change="marketListPrefix(selectedMarketPrefix[idx].master_market_area_code, idx)"
                                >
                                    <el-option
                                        v-for="(item, idx) in listMarkets"
                                        :key="item.code"
                                        :label="item.name"
                                        :value="item.code"
                                        :disabled="isMarket(item.code) ? true : false"
                                    />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="2" :xs="22" :sm="22" :md="22" :lg="11" :xl="11">
                            <label>
                                Prefix Name
                            </label>
                            <el-form-item>
                                <el-select
                                    multiple
                                    collapse-tags
                                    v-model="selectedMarketPrefix[idx].prefixs"
                                    style="width:100%;"
                                    placeholder="Prefix Name"
                                    :max-collapse-tags="3"
                                >
                                    <el-option
                                        v-for="item in listMarketPrefixs[idx].listPrefix"
                                        :key="item.prefix_code"
                                        :label="`(${item.prefix_code}) ${item.country_name}`"
                                        :value="item.prefix_code"
                                        :disabled="isPrefix(item.prefix_code, idx) ? true : false"
                                    />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col v-if="idx!==0" :xs="2" :sm="2" :md="2" :lg="2" :xl="2">
                            <el-button @click="deleteMarketPrefix(idx)" class="mt-20" type="danger" size="mini">
                                <i class="mdi mdi-delete-forever"></i> 
                            </el-button>
                        </el-col>
                    </el-card>
                </el-row>

                <el-row v-if="selectedMarketPrefix.length < listMarkets.length" class="mt-20 mb-20">
                    <el-button @click="addMarketPrefix" style="width: 100%;" type="primary">+ Add Market and Prefix</el-button>
                </el-row>
            
                <el-row>
                    <el-button @click="addMarketPrefixArea()" type="primary">Add</el-button>
                    <el-button @click="dialogMarketPrefixArea=false">Cancel</el-button>
                </el-row>
            </el-form>
        </el-dialog>

        <el-dialog title="Market quota limit for prepaid (Topup) and postpaid (Invoice)" :visible.sync="dialogConfigQuota" width="75%">
            <el-row class="mb-10">
                <el-card
                    v-for="(item, idx) in marketQuota"
                    :key="item.master_market_area_id"
                    class="mb-5"
                >
                    <el-form
                        :inline="true"
                        label-position="top"
                        class="demo-form-inline mb-30"
                    >
                        <el-form-item label="Market Name" class="mb-5 pr-10">
                            <p style="width: 11em;">{{`${marketQuota[idx].master_market_area_name} ${marketQuota[idx].is_delete ? '(Deactivated)' : '(Active)'}`}}</p>
                        </el-form-item>
                        <el-form-item label="Credit Category" class="mb-5 mr-5">
                            <dl style="list-style: none;">
                                <dt>Limit Prepaid</dt>
                                <dt>Limit PostPaid</dt><br/>
                                <dt>Limit Bundle</dt>
                            </dl>
                        </el-form-item>
                        <el-form-item label="Authentication" class="mb-5 mr-5">
                            <dl style="list-style: none;">
                                <dt>
                                    <el-input
                                        type="text"
                                        size="medium"
                                        style="width:150px;"
                                        :value="marketQuota[idx].authentication_quota"
                                        disabled
                                    />
                                </dt>
                                <dt>
                                    <el-input
                                        type="text"
                                        size="medium"
                                        style="width:150px;"
                                        @keypress.native="numberOnly"
                                        v-model="marketQuota[idx].authentication_limit"
                                        :disabled="marketQuota[idx].is_delete"
                                    /><br/>
                                    <el-checkbox :disabled="item.is_delete" v-model="marketQuota[idx].is_authentication_max" label="Max" size="medium" />
                                </dt>
                                <dt>
                                    <el-input
                                        type="text"
                                        size="medium"
                                        style="width:150px;"
                                        @keypress.native="numberOnly"
                                        v-model="marketQuota[idx].authentication_bundle"
                                        :disabled="marketQuota[idx].is_delete"
                                    />
                                </dt>
                            </dl>
                        </el-form-item>
                        <el-form-item label="Marketing" class="mb-5 mr-5">
                            <dl style="list-style: none;">
                                <dt>
                                    <el-input
                                        type="text"
                                        size="medium"
                                        style="width:150px;"
                                        :value="marketQuota[idx].marketing_quota"
                                        disabled
                                    />
                                </dt>
                                <dt>
                                    <el-input
                                        type="text"
                                        size="medium"
                                        style="width:150px;"
                                        @keypress.native="numberOnly"
                                        v-model="marketQuota[idx].marketing_limit"
                                        :disabled="marketQuota[idx].is_delete"
                                    /><br/>
                                    <el-checkbox :disabled="marketQuota[idx].is_delete" v-model="marketQuota[idx].is_marketing_max" label="Max" size="medium" />
                                </dt>
                                <dt>
                                    <el-input
                                        type="text"
                                        size="medium"
                                        style="width:150px;"
                                        @keypress.native="numberOnly"
                                        v-model="marketQuota[idx].marketing_bundle"
                                        :disabled="marketQuota[idx].is_delete"
                                    />
                                </dt>
                            </dl>
                        </el-form-item>
                        <el-form-item label="Utility" class="mb-5 mr-5">
                            <dl style="list-style: none;">
                                <dt>
                                    <el-input
                                        type="text"
                                        size="medium"
                                        style="width:150px;"
                                        :value="marketQuota[idx].utility_quota"
                                        disabled
                                    />
                                </dt>
                                <dt>
                                    <el-input
                                        type="text"
                                        size="medium"
                                        style="width:150px;"
                                        @keypress.native="numberOnly"
                                        v-model="marketQuota[idx].utility_limit"
                                        :disabled="marketQuota[idx].is_delete"
                                    /><br/>
                                    <el-checkbox :disabled="marketQuota[idx].is_delete" v-model="marketQuota[idx].is_utility_max" label="Max" size="medium" />
                                </dt>
                                <dt>
                                    <el-input
                                        type="text"
                                        size="medium"
                                        style="width:150px;"
                                        @keypress.native="numberOnly"
                                        v-model="marketQuota[idx].utility_bundle"
                                        :disabled="marketQuota[idx].is_delete"
                                    />
                                </dt>
                            </dl>
                        </el-form-item>
                        <el-form-item label="Service" class="mb-5 mr-5">
                            <dl style="list-style: none;">
                                <dt>
                                    <el-input
                                        type="text"
                                        size="medium"
                                        style="width:150px;"
                                        :value="marketQuota[idx].service_quota"
                                        disabled
                                    />
                                </dt>
                                <dt>
                                    <el-input
                                        type="text"
                                        size="medium"
                                        style="width:150px;"
                                        @keypress.native="numberOnly"
                                        v-model="marketQuota[idx].service_limit"
                                        :disabled="marketQuota[idx].is_delete"
                                    /><br/>
                                    <el-checkbox :disabled="marketQuota[idx].is_delete" v-model="marketQuota[idx].is_service_max" label="Max" size="medium" />
                                </dt>
                                <dt>
                                    <el-input
                                        type="text"
                                        size="medium"
                                        style="width:150px;"
                                        v-model="marketQuota[idx].service_bundle"
                                        @keypress.native="numberOnly"
                                        :disabled="marketQuota[idx].is_delete"
                                    />
                                </dt>
                            </dl>
                        </el-form-item>
                    </el-form>
                </el-card>
            </el-row>

            <el-button type="primary" @click="addConfigQuota()" :loading="loadingBtn">Save</el-button>
            <el-button @click="dialogConfigQuota=false">Cancel</el-button>
        </el-dialog>

        <el-dialog title="Delete Number" :visible.sync="dialogDeleteNumber">
            <p>
                Are you sure want to delete this number (<b>{{ selectedPhoneNumberToDelete }}</b>) data?
            </p>
            <el-button type="primary" @click="doDeleteNumber" :loading="loadingBtnDelete">Delete</el-button>
            <el-button type="danger" @click="dialogDeleteNumber=false">Cancel</el-button>
        </el-dialog>

        <el-dialog title="Delete Product" :visible.sync="dialogDelete">
            <h4 style="font-weight:bold;">LIST PRODUCT FOR <el-tag style="font-size:18px;">{{selectedPhoneNumberToDelete}}</el-tag></h4>
            <el-card class="mb-10" v-for="(prd, key) in product[selectedEditNumber].product" :key="key" style="box-shadow:none;">{{prd.productName}} ({{prd.productSKU}}) <strong>(IDR {{prd.price}})</strong></el-card>
            <br>
            <!-- <h4 style="font-weight:bold;">DELETING</h4> -->
            <el-form>
                <el-input type="text" v-model="selectedPhoneNumberToDelete" disabled />
                &nbsp;&nbsp;
                <el-select
                filterable
                v-model="selectedProductToDelete" placeholder="Product SKU" style="width:100%;">
                    <el-option
                        v-for="(prd) in product[selectedDeleteNumber].product" :key="prd._id"
                        :label="prd.productSKU"
                        :value="prd._id">
                        <span style="float: left;" class="mr-60">{{ prd.productSKU }} ({{prd.productName}})</span>

                        <span style="float: right; color: #8492a6; font-size: 14px" v-if="prd.minPrice=='' || prd.minPrice==null">(Product Minimum Price : -)</span>
                        <span style="float: right; color: #8492a6; font-size: 14px" v-else>(Product Minimum Price : IDR {{formatPrice (prd.minPrice)}})</span>

                        <span style="float: right; color: #8492a6; font-size: 14px" v-if="prd.price=='' || prd.price==null" class="mr-10">-</span>
                        <span style="float: right; color: #8492a6; font-size: 14px" v-else class="mr-10">IDR <strong>{{ prd.price }}</strong></span>
                        <!-- <span style="float: left;" class="mr-60">{{ prd.productName }}</span>
                        <span style="float: right; color: #8492a6; font-size: 14px">IDR {{ prd.price }}</span> -->
                    </el-option>
                </el-select>
                <br><br>
                <el-button type="danger" @click="doDeleteProduct" :loading="loadingBtn">Delete</el-button>
            </el-form>
        </el-dialog>

        <el-dialog title="Add Service User" :visible.sync="dialogAddServiceUser">
            <el-form>
                <el-form-item>
                    <el-input type="textarea" v-model="form.token_whatsapp" placeholder="Insert Credentials Token"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="form.phone_wa" placeholder="Insert Phone Number"></el-input>
                </el-form-item>
                <el-button type="primary" size="mini" @click="addServiceUser">Save</el-button>
                <el-button type="danger" size="mini" @click="dialogAddServiceUser=false">Close</el-button>
            </el-form>
        </el-dialog>

        <el-dialog title="Update Number" :visible.sync="dialogEditNumber">
            <el-form>
                <el-form-item>
                    <el-input type="text" v-model="selectedPhoneNumberToUpdate" disabled></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="newPhoneNumber" placeholder="Insert New Phone Number"></el-input>
                </el-form-item>
                <el-button type="primary" size="mini" @click="doUpdatePhoneNumber" :loading="loadingBtn">Save</el-button>
                <el-button type="danger" size="mini" @click="dialogEditNumber=false">Close</el-button>
            </el-form>
        </el-dialog>
        
        <el-dialog title="Add Product" :visible.sync="dialogAddProduct">
            <el-form>
                <p>
                    Add product <b>{{ getProductName(selectedProductAssigned) }}</b> to <b>{{ selectedPhoneNumber }}</b>?
                </p>
                <el-form-item v-if="productAssign.productName && productAssign.productName.toLowerCase() != 'whatsapp conversation' && productAssign.productName.toLowerCase() != 'maintenance'">
                    <el-input v-model="formAddProduct.allowed_prefix" placeholder="(Optional) Insert allowed prefix, separate with comma(s). Leave empty for default (allow all prefix)"></el-input>
                </el-form-item>
                <el-button :loading="loadingBtn" type="primary" size="mini" @click="addProductUser">Save</el-button>
                <el-button type="danger" size="mini" @click="dialogAddProduct=false">Close</el-button>
            </el-form>
        </el-dialog>

        <div v-loading="loadingConsumenProduct">
            <!-- <span>
                <strong>{{ customerName }}</strong>
            </span>
            <br><br> -->
            <el-alert
                title="Info"
                type="info"
                :closable="false"
                description="If this account has not phone number and token, please Add Service from tab 'Detail' for the first time."
                show-icon>
            </el-alert>
            <br>
            <span>
                <el-select
                    filterable
                    v-model="selectedPhoneNumber" @change="handleSelectNumber" placeholder="Select phone number" v-loading="loadingNumber">
                    <el-option
                        v-for="numb in number" :key="numb"
                        :label="numb"
                        :value="numb">
                    </el-option>
                </el-select>&nbsp;
                <el-select
                    filterable
                    @change="handleChangeProductName"
                    v-model="selectedProductName" placeholder="Select Product Name">
                    <el-option
                    v-for="item in nameOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </el-select>&nbsp;
                <el-select
                    v-if="selectedProductName.toLowerCase() == 'whatsapp template based'"
                    filterable
                    @change="handleChangeProductType"
                    v-model="selectedProductType" placeholder="Select Product Type">
                    <el-option
                        v-for="item in options4"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                </el-select>
                <el-select
                    v-if="selectedProductName.toLowerCase() == 'whatsapp conversation'"
                    filterable
                    @change="handleChangeProductType"
                    v-model="selectedProductType" placeholder="Select Product Type">
                    <el-option
                        v-for="item in options2"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                </el-select>
                <el-select
                    v-else-if="selectedProductName.toLowerCase() == 'maintenance'"
                    filterable
                    @change="handleChangeProductType"
                    v-model="selectedProductType" placeholder="Select Product Type">
                    <el-option
                        v-for="item in options3"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                </el-select>
                <el-select
                    v-else-if="selectedProductName.toLowerCase() !== 'whatsapp template based'"
                    filterable
                    @change="handleChangeProductType"
                    v-model="selectedProductType" placeholder="Select Product Type">
                    <el-option
                        v-for="item in options1"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                </el-select>&nbsp;
                <el-select
                :disabled="isDisabled"
                    filterable
                    v-model="selectedProductAssigned" placeholder="Select Product SKU">
                    <el-option
                        v-for="(prd, key) in listProduct2" :key="key"
                        :label="prd.productSKU"
                        :value="prd.aliasName">
                    </el-option>
                </el-select>&nbsp;
                <el-button type="primary" icon="el-icon-plus" @click="doShowDialogAddProduct" :loading="loadingBtn">Add</el-button>
            </span>
            <div class="page-profile-edit mt-20" v-for="(data, key) in product" :key="key" v-if="number.length > 0">
                <el-card class="card-base scrollable only-y" style="color:white; background: linear-gradient(45deg, rgb(85,85,85,1) 0%, rgba(36, 147, 147) 100%);">
                    <span style="float:right">
                        <el-button size="mini" icon="el-icon-edit" type="default" @click="doShowDialogEditNumber(key)"></el-button>
                        <el-button size="mini" icon="el-icon-delete" type="danger" @click="doShowDialogDeleteNumber(key)"></el-button>
                    </span>
                    <table>
                        <tbody>
                            <tr>
                                <td style="font-weight: bold">
                                    <span>Phone Number</span><br><br>
                                    <span type="warning" style="color: #ffffff; border-radius:5px; font-weight:bold; font-size:18px; margin-top:30px; background-color:#333333; padding:10px;">{{ data.number }}</span>
                                </td>
                            </tr>
                        </tbody>
                        <br>
                        <tbody v-if="product.length > 0">
                            <tr>
                                <td colspan="2" style="width: 10%; font-weight: bold">
                                    Product
                                    <span v-if="data.product" style="float:right; margin-right: 10px">
                                        <el-button size="mini" icon="el-icon-edit" type="default" @click="doShowDialogEdit(key, data.number)" />
                                        <el-button size="mini" icon="el-icon-delete" type="danger" @click="doShowDialogDelete(key)" />
                                    </span>
                                </td>
                            </tr>
                            <tr v-for="(dt, ky) in data.product" :key="ky">
                                <td colspan="2">
                                    <dd>{{ dt.productName }}</dd>
                                    <dd>
                                        <el-col :span="16" :md="16" :sm="24" :xs="24" class="col-p">
                                            <span style="font-weight: bold">{{ $t('consumen.product.type') }}</span>
                                        </el-col>
                                        <el-col v-if="dt.productName.toLowerCase() != 'whatsapp conversation'" :span="8" :md="8" :sm="24" :xs="24" class="col-p">
                                            {{ capitalizeFirstLetter(dt.type) }}
                                        </el-col>
                                        <el-col v-else :span="8" :md="8" :sm="24" :xs="24" class="col-p">
                                            {{ capitalizeFirstLetter(dt) }}
                                        </el-col>
                                    </dd>
                                    <dd v-if="dt.productName.toLowerCase() != 'whatsapp conversation' && dt.productName.toLowerCase() != 'maintenance'">
                                        <el-col :span="16" :md="16" :sm="24" :xs="24" class="col-p">
                                            <span style="font-weight: bold">{{ $t('consumen.product.price') }}</span>
                                        </el-col>
                                        <el-col :span="8" :md="8" :sm="24" :xs="24" class="col-p">
                                            {{ formatPrice(dt.price) }}
                                        </el-col>
                                    </dd>
                                    <dd>
                                        <el-col :span="16" :md="16" :sm="24" :xs="24" class="col-p">
                                            <span v-if="dt.productName.toLowerCase() != 'whatsapp conversation' && dt.productName.toLowerCase() != 'maintenance'" style="font-weight: bold">{{ $t('consumen.product.minPrice') }}</span>
                                            <span v-else style="font-weight: bold">Monthly Fee</span>
                                        </el-col>
                                        <el-col :span="8" :md="8" :sm="24" :xs="24" class="col-p">
                                            <template>
                                            <span v-if="dt.minPrice=='' || dt.minPrice==null">-</span>
                                            <span v-else>{{ formatPrice(dt.minPrice) }}</span>
                                            </template>
                                        </el-col>
                                    </dd>
                                    <dd>
                                        <el-col :span="16" :md="16" :sm="24" :xs="24" class="col-p">
                                            <span style="font-weight: bold">Service Fee</span>
                                        </el-col>
                                        <el-col v-if="dt.productName.toLowerCase() != 'whatsapp conversation' && dt.productName.toLowerCase() != 'maintenance'" :span="8" :md="8" :sm="24" :xs="24" class="col-p">
                                            <template>
                                            <span v-if="dt.serviceFee=='' || dt.serviceFee==null">-</span>
                                            <span v-else>{{ dt.serviceFee }} %</span>
                                            </template>
                                        </el-col>
                                        <el-col v-else :span="8" :md="8" :sm="24" :xs="24" class="col-p">
                                            <template>
                                            <span v-if="dt.product_service.type == 'percentage'">{{ dt.product_service.fee }} %</span>
                                            <span v-else>{{formatPrice(dt.product_service.fee)}}</span>
                                            </template>
                                        </el-col>
                                    </dd>
                                    <dd v-if="dt.productName.toLowerCase() == 'whatsapp conversation' || dt.productName.toLowerCase() == 'maintenance'">
                                        <el-col :span="16" :md="16" :sm="24" :xs="24" class="col-p">
                                            <span style="font-weight: bold">Tax</span>
                                        </el-col>
                                        <el-col :span="8" :md="8" :sm="24" :xs="24" class="col-p">
                                            <template>
                                            <span v-if="dt.tax">{{ dt.tax }} %</span>
                                            <span v-else>-</span>
                                            </template>
                                        </el-col>
                                    </dd>
                                    <dd v-if="dt.productName.toLowerCase() == 'whatsapp conversation' && dt.type == 'notification_caping_plafon'">
                                        <el-col :span="16" :md="16" :sm="24" :xs="24" class="col-p">
                                            <span style="font-weight: bold">Hybrid Type</span>
                                        </el-col>
                                        <el-col :span="8" :md="8" :sm="24" :xs="24" class="col-p">
                                            <template>
                                            <span v-if="dt.hybrid_type">{{ dt.hybrid_type }}</span>
                                            <span v-else>-</span>
                                            </template>
                                        </el-col>
                                    </dd>
                                    <dd v-if="dt.type.indexOf('tier') != -1">
                                        <el-col :span="16" :md="16" :sm="24" :xs="24" class="col-p">
                                            <span style="font-weight: bold">{{ $t('consumen.product.tier') }}</span>
                                        </el-col>
                                        <el-col :span="8" :md="8" :sm="24" :xs="24" class="col-p">
                                            <template>
                                                <el-row v-for="(tier, index) in dt.tier" :key="index">
                                                    <el-col :span="24" :md="24" :sm="24" :xs="24" class="col-p">
                                                        <span>{{ formatPrice(tier.price) }} ({{ tier.from.toLocaleString() }} to {{ tier.to == "-" ? '&#8734;' : tier.to.toLocaleString() }})</span>
                                                    </el-col>
                                                </el-row>
                                            </template>
                                        </el-col>
                                    </dd>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </el-card>
            </div>
            <div v-else>
                <img src="../../assets/images/no_data.png" alt="No data image" class="img-center"/>
            </div>
        </div>
    </div>
</template>
<script>
import config from '../../config'
import api from '@/networkClient'
import CountryFlag from 'vue-country-flag'
const CountryCodes = require('country-codes-list');
import axios from 'axios';

export default {
    props: {
        waUserDetail: {
            type: Object
        },
        listProduct: {
            type: Array
        },
        listProductUser:{
            type: Array,
            required: false
        },
        customerName: {
            type: String
        },
        loadingPage: {
            type: Boolean,
            required: false
        }
    },
    data() {
        return {
            radio_cbp_max: "",
            bi_max: false,
            ui_max: false,
            intern_max: false,
            isMax:{
                ui:false,
                bi:false,
            },
            isDisabled: true,
            hybrid_type: 0,
            nameOptions: [
                {
                    value: 'Whatsapp Template Based',
                    label: 'Whatsapp Template Based'
                },
                {
                    value: 'Whatsapp Conversation',
                    label: 'Whatsapp Conversation'
                },
                {
                    value: 'Maintenance',
                    label: 'Maintenance'
                },
                {
                    value: 'Whatsapp Notification',
                    label: 'Whatsapp Notification'
                },
                {
                    
                    value: 'Whatsapp Traffic Outbond',
                    label: 'Whatsapp Traffic Outbond'
                },
                {
                    value: 'Shorten URL',
                    label: 'Shorten URL'
                },
                {
                    value: 'Telegram Integration',
                    label: 'Telegram Integration'
                },
                {
                    value: 'Line Integration',
                    label: 'Line Integration'
                }
            ],
            options1: [{
                value: 'notification',
                label: 'Notification'
            }, {
                value: 'notification_caping',
                label: 'Notification Caping'
            }, {
                value: 'notification_caping_plafon',
                label: 'Notification Caping Plafon'
            },{
                value: 'notification_prepaid',
                label: 'Notification Prepaid'
            }, {
                value: 'subscribe',
                label: 'Subscribe'
            }, {
                value: 'traffic',
                label: 'Traffic'
            }, {
                value: 'traffic_tier',
                label: 'Traffic Tier'
            }, {
                value: 'shorten',
                label: 'Shorten URL'
            }, {
                value: 'telegram',
                label: 'Telegram'
            }, {
                value: 'line',
                label: 'Line'
            }],
			options2:[{
				value: 'notification',
				label: 'CBP Invoice'
			}, {
				value: 'notification_caping',
				label: 'CBP Caping'
			}, {
				value: 'notification_caping_plafon',
				label: 'CBP Hybrid'
			}],
            options3:[{
				value: 'chatbot',
				label: 'Chatbot'
			}],
            options4: [
				{
					value: 'wtb_hybrid',
					label: 'Hybrid Payment Method'
				}
			],
            listProduct2: [],
            dialogFormVisible: false,
            multipleSelection:[],
            country: [],
            tableData: [],
            discountType:[
				{
				value: 'percentage',
				label: 'Percentage'
				}, {
					value: 'currency',
					label: 'Currency'
				}
			],
            discount: false,
            countries:[],
            totalCountries: 0,
            hidden: false,
            dialogChangePrice: false,
            dialogEditChangePrice: false,
            dialogDelete: false,
            dialogAddServiceUser: false,
            dialogEditNumber: false,
            dialogDeleteNumber: false,
            dialogAddProduct: false,
            dialogMarketPrefixArea: false,
            dialogConfigQuota: false,
            btnLoadingAddChangePrice: false,
            newPhoneNumber: '',
            form: {
                phone_wa: "",
                token_whatsapp: ""
            },
            formAddProduct: {
                allowed_prefix: "",
            },
            productAssign:{},
            selectedPhoneNumber: "",
            selectedProductAssigned: "",
            selectedProductToUpdate: "",
            selectedProductToDelete: "",
            selectedPriceToUpdate: "",
            selectedProductName: "",
            selectedProductType: "",
            selectedEditNumber: 0,
            selectedDeleteNumber: 0,
            newPrice:"",
            loadingConsumenProduct:false,
            loadingBtn:false,
            loadingProduct:true,
            loadingUpdateNumber: false,
            loadingNumber:false,
            loadingBtnDelete: false,
            number:[],
            selectedPhoneNumberToUpdate: "",
            product: [ { product: [] } ],
            selectedPhoneNumberToDelete: "",
            selectedProductObject: {
                fbbm_id:"",
                type: "",
                tier: [],
                serviceType: "percentage"
            },
            options: [{
                value: 'percentage',
                label: 'Percentage'
                }, {
                value: 'constant',
                label: 'Currency (Rp)'
            }],
            marketNamePrefix: [],
            areaMarket: [],
            countries: [],
            marketPrefixLength: [],
            marketQuotaLimit: [
                {
                    market_name: '',
                    authentication: {
                        limit_prepaid: '',
                        limit_postpaid: '',
                        limit_bundle: ''
                    },
                    marketing: {
                        limit_prepaid: '',
                        limit_postpaid: '',
                        limit_bundle: ''
                    },
                    utility: {
                        limit_prepaid: '',
                        limit_postpaid: '',
                        limit_bundle: ''
                    },
                    service: {
                        limit_prepaid: '',
                        limit_postpaid: '',
                        limit_bundle: ''
                    }
                }
            ],
            listMarkets: [],
            listPrefixs: [],
            listPrefixCodes: [],
            listMarketPrefixs: [],
            listConfigQuota: [],
            catalogId: '',
            fbbmId: '',
            editProduct: {
                remark: '',
                price: 0,
                productName: '',
                phone_number: '',
                id: '',
                fbbmId: '',
                catalogId: '',
                markets: []
            },
            objectUploadFile: '',
            marketActive: [],
            marketQuota: [],
            listMarketPrefixPhone: [],
            selectedMarketPrefix: []
        }
    },
    components: {
        CountryFlag
    },
    methods: {
        log(data) {
            console.log(data, " <<data");
        },
        numberOnly(e, idx) {
            var key = window.event ? e.keyCode : e.which;

            let isNumber = _.indexOf([8, 9, 27, 13, 190, 43], e.keyCode)
            if ( isNumber !== -1 ||
                // Allow: Ctrl+C, Command+C
                (e.keyCode === 86 && (e.ctrlKey === true || e.metaKey === true)) ||
                // Allow: Ctrl+A, Command+A
                (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
                // Allow: Ctrl+R, Command+R
                (e.keyCode === 82 && (e.ctrlKey === true || e.metaKey === true)) ||
                // Allow: home, end, left, right, down, up
                (e.keyCode > 42 && e.keyCode <= 49 && _.indexOf([44,45,46,47], e.keyCode) == -1)) {
                // let it happen, don't do anything
                return
            }
            // Ensure that it is a number and stop the keypress
            if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode > 96 || e.keyCode < 200)) {
                e.preventDefault();
            }
        },
        isSetMax() {
            var data = this.marketQuota;
            let isModal = false;
            data.map(item => {
                if (
                    item.is_authentication_max && +item.authentication_bundle > +item.authentication_limit ||
                    item.is_marketing_max && +item.marketing_bundle > +item.marketing_limit ||
                    item.is_utility_max && +item.utility_bundle > +item.utility_limit ||
                    item.is_service_max && +item.service_bundle > +item.service_limit
                ) {
                    isModal=true;
                }
            })

            if(isModal) {
                this.$message.error({
					showClose: true,
					duration: 5000,
					message: "Max is set! Limit Bundle cannot more than Limit PostPaid!"
				});
            } else {
                this.dialogConfigQuota=false;
            }
            return isModal;
        },
        isMarket(country_code) {
            return _.find(this.selectedMarketPrefix, (v) => {
                return v.master_market_area_code === country_code
            })
        },
        isPrefix(prefix_code, idx) {
            return _.find(this.selectedMarketPrefix[idx].prefix, (v) => {
                if (v === prefix_code) {
                    return true
                } else {
                    return false
                }
            })
        },
        addMarketPrefix() {
            let data = {
                market_name: '',
                master_market_area_id: '',
                master_market_area_name: '',
                prefix: []
            }

            let addPrefix = {
                master_market_id: '',
                listPrefix: []
            }

            this.listMarketPrefixs.push(addPrefix);
            this.selectedMarketPrefix.push(data);
        },
        marketListPrefix(market_name, idx) {
            var data = {}
            this.listMarkets.map((item) => {
                if (item.code === market_name) {
                    data = item;
                    this.selectedMarketPrefix[idx].master_market_area_id = item.id;
                    this.selectedMarketPrefix[idx].master_market_area_name = item.name;
                    this.listPrefixs = item.master_prefixs;
                    this.listMarketPrefixs[idx].listPrefix = item.master_prefixs;
                    this.listMarketPrefixs[idx].master_market_id = item.id;
                }
            })
            this.listPrefixs = data.master_prefixs;
        },
        deleteMarketPrefix(idx) {
            this.selectedMarketPrefix.splice(idx, 1);
        },
        async renderMedia(object){
            let size =
                object &&
                object.file &&
                object.file.size
                    ? object.file.size
                    : null;

            if(size >= 104857600){
                this.closeDialog()
                this.$swal(this.$t('error'), "Maximum file upload size is 100 MB", "warning")
                return
            }

            this.objectUploadFile = object.file;
            this.uploadMedia();
        },
        async uploadMedia() {
            let formData = new FormData();
            formData.append('id', this.selectedProductObject._id)
            formData.append('files', this.objectUploadFile)
            formData.append('source', 'product')

            let apiOptions = {
                timeout: 60000 * 5,
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }

            await axios.post(config.baseApi + 'master-media/upload', formData, apiOptions).then(resp => {
                var status =
                    resp &&
                    resp.data &&
                    resp.data.ec
                        ? resp.data.ec
                        : null;
                
                if (status === 200) {
                    this.$message.success({
						showClose: true,
						duration: 5000,
						message: "Uploaded the file successfully"
					});
                } else {
                    this.$message.error({
						showClose: true,
						duration: 5000,
						message: "Uploaded the file failed"
					});
                }
            }).catch(err => {
                console.error(err);
            })
        },
        lengthPrefix() {
            var data = this.selectedMarketPrefix;
            let tempData = []
            data.map(item => {
                let arrData = item && item.prefixs ? item.prefixs : [];
                arrData.map(item2 => {
                    tempData.push(item2);
                })
            })
            this.marketPrefixLength = tempData;
        },
        async getListMarket(){
			await api({
				method: "get",
				url: config.baseApi + "data/market-area"
			}).then(resp => {
                const status =
                    resp &&
                    resp.data &&
                    resp.data.ec
                        ? resp.data.ec
                        : null;
                const data =
                    resp &&
                    resp.data &&
                    resp.data.data &&
                    resp.data.data.rows
                        ? resp.data.data.rows
                        : [];
				if(status == 200){
                    this.areaMarket = data;
				}
			}).catch(err => {
				console.log("failed", err)
			})
		},
        async addMarketPrefixArea(idx) {
            let custId = this.$route.params.consumen;
            var market = this.selectedProductObject.markets;
            this.lengthPrefix();
            var tempData = {
                productName: this.selectedProductObject.productName,
                phone_number: this.selectedPhoneNumberToUpdate,
                id: this.selectedProductObject._id,
                remark: this.editProduct.remark,
                price: this.editProduct.price,
                markets: []
            }

            this.selectedMarketPrefix.map(item => {
                let temp = this.selectedMarketPrefix.filter(el => el.master_market_area_id === item.master_market_area_id)

                if(temp.length > 0) {
                    let tempPrefix = 
                        {
                            master_market_area_code: item.master_market_area_code,
                            master_market_area_id: item.master_market_area_id,
                            master_market_area_name: item.master_market_area_name,
                            prefixs: []
                        };

                    temp[0].prefixs.map(el => {
                        let codeTemp = {
                            code: el.code ? el.code : el
                        }
                        tempPrefix.prefixs.push(codeTemp);
                    })
                    
                    tempPrefix.prefixs = tempPrefix.prefixs.filter((value, index, self) =>
                        index === self.findIndex((t) => (
                            t.code === value.code
                        ))
                    )

                    tempData.markets.push(tempPrefix);
                }
            })

            if (this.validate('market')) {
                this.$message.error("Please choose market area & prefix area!", { duration: 5000 })
            } else {
                await api({
                    method: "patch",
                    data: tempData,
                    url: config.baseApi + `master-consumen/${custId}/product-market-area`,
                }).then(res => {
                    var data =
                        res &&
                        res.data &&
                        res.data.data.product
                            ? res.data.data.product
                            : '';
    
                    this.marketQuota = data.markets;
                    this.editProduct.markets = data.markets;
                    this.dialogMarketPrefixArea=false;
                }).catch(err => {
                    console.error(err);
                })
            }
        },
        addConfigQuota() {
            this.isSetMax()
        },
        async configQuota() {
            this.dialogConfigQuota=true;
        },
        async addEditProduct() {
            let custId = this.$route.params.consumen;
            this.editProduct.id = this.selectedProductObject._id;
            this.editProduct.productName = this.selectedProductObject.productName;
            this.editProduct.phone_number = this.selectedPhoneNumberToUpdate;
            this.editProduct.catalog_id = this.catalogId;
            this.editProduct.fbbm_id = this.fbbmId;
            this.btnLoadingAddChangePrice = true;

            await api({
                method: "patch",
                data: this.editProduct,
                url: config.baseApi + `master-consumen/${custId}/product`,
            }).then(res => {
                let status =
                    res &&
                    res.data &&
                    res.data.ec
                        ? res.data.ec
                        : null;
                if (status == 200) {
                    this.detailConsumenProduct();
                    this.$swal(this.$t('success'), this.$t('success'), "success").then(this.clear())
                    this.dialogEditChangePrice = false;
                }
                this.btnLoadingAddChangePrice = false;
			}).catch(err => {
                console.error(err);
                this.btnLoadingAddChangePrice = false;
                this.dialogEditChangePrice = false;
            })
        },
        handleMax(val){
            if (this.isMax.bi) {
                this.selectedProductObject.is_bi_max = true
                this.bi_max = true
            }
            else {
                this.selectedProductObject.is_bi_max = false
                this.bi_max = false
            }

            if (this.isMax.ui) {
                this.selectedProductObject.is_ui_max = true
                this.ui_max = true
            }
            else {
                this.selectedProductObject.is_ui_max = false
                this.ui_max = false
            }
        },
        handleChangeProductName(val){
            this.isDisabled = true
            this.selectedProductType = ''
            this.selectedProductAssigned = ''
        },
        handleChangeProductType(val){
            this.selectedProductAssigned = ''
            if (this.selectedProductName && this.selectedPhoneNumber) {
                this.isDisabled = false
                if (this.selectedProductName.toLowerCase() == 'whatsapp conversation') {
                        
                    this.listProduct2 = this.listProduct.filter(v => v.productName.toLowerCase() == 'whatsapp conversation' && v.type == val)
                } else if (this.selectedProductName.toLowerCase() == 'maintenance') {
                    this.listProduct2 = this.listProduct.filter(v => v.productName.toLowerCase() == 'maintenance' && v.type == val)
                } else if (this.selectedProductName.toLowerCase() == 'whatsapp template based') {
                    this.listProduct2 = this.listProduct.filter(v => v.productName.toLowerCase() == 'whatsapp template based' && v.type == val)
                } else {
                    this.listProduct2 = this.listProduct.filter(v => v.productName.toLowerCase() != 'whatsapp conversation' && v.type == val)
                }
            }
        },
        handleSelectNumber(val){
            this.isDisabled = true
            this.selectedProductName = ''
            this.selectedProductType = ''
            this.selectedProductAssigned = ''
            let fillNumb = this.product.find(el => el.number == val)
            this.listProduct2 = [...this.listProduct]
            if (fillNumb.product && fillNumb.product.length > 0) {
                fillNumb.product.forEach(el => {
                    this.listProduct.forEach((val,i) => {
                        if (val._id == el._id) {
                            this.listProduct2.splice(i,1)
                        }
                    })
                })

            }
            
        },
        handleChangeServiceType(val){
            this.selectedProductObject.product_service.fee = 0
        },
        clickPrefix(){
            this.dialogFormVisible = true
            if(this.selectedProductObject.prefix.length > 0){
                let found = null
                let arrayFound = []

                this.selectedProductObject.prefix.forEach((el,i) => {
                    // this.selectedProductObject.allowedPrefix.push(el.code_prefix)
                    el.code_prefix = el.code_prefix
                    found = this.countries.find(element => `+${element.countryCallingCode}` == el.code_prefix);
                    if (found) {
                        // this.selectedProductObject.prefix[i].discount = found.prefixCode == '62' ? {}: false
                        arrayFound.push(found)
                        // if (found.prefixCode == '62') {
                        //     this.discount = true
                        // }
                    }
                })

                if (arrayFound.length > 0) {
                    this.country = arrayFound.map(el => el.countryNameEn)
                    this.tableData = arrayFound
                    // console.log(arrayFound);
                    // console.log(this.tableData);
                    this.handleSelectionChange(arrayFound)
                    // this.multipleSelection = arrayFound
                }
                
            } 

            if (this.tableData.length > 0) {
                setTimeout(() => {
                    this.$refs.multipleTable.clearSelection();
                    this.toggleSelection(this.tableData)
                }, 700);
                
            }
        },
        toggleSelection(rows) {
            // console.log(rows);
            if (rows) {
                rows.forEach(row => {
                    this.$refs.multipleTable.toggleRowSelection(row);
                });
            } else {
            	this.$refs.multipleTable.clearSelection();
				this.multipleSelection = []
                this.country = []
                this.tableData = []
            }
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        async handleChangeSelectedCountry(val){
            this.tableData = _.filter(this.countries, (v) => {
                return val.includes(v.countryNameEn)
            })
            
            await this.handleSelectionChange(this.tableData)
            if (this.tableData.length > 0) {
                setTimeout(() => {
                    this.$refs.multipleTable.clearSelection();
                    this.toggleSelection(this.tableData)
                }, 700);
            }
            // console.log(this.tableData);
        },
        totalAfterDisc(type, val, disc = 0){
            let res = 0
			if (type == 'percentage') {
                res = (val - (val * disc / 100))
                if (res% 1 != 0) res = res.toFixed(2)
				return res
			}
			else if (type == 'currency') {
                res = (val - disc)
                if (res% 1 != 0) res = res.toFixed(2)
				return res
			}
			else {
                res = val
				return res
			}
		},
        doShowDialogAddProduct(){
            if(_.isEmpty(this.selectedPhoneNumber) || _.isEmpty(this.selectedProductAssigned) || _.isEmpty(this.selectedProductName) || _.isEmpty(this.selectedProductType)){
                this.$message.error("Please select all filter", { duration: 5000 })
            } else{
                let find = this.listProduct.find(el => el.aliasName == this.selectedProductAssigned)
                // console.log(find);
                if (find) {
                    this.formAddProduct.allowed_prefix = find.allowedPrefix && find.allowedPrefix.length > 0 ? find.allowedPrefix.join(","):""
                }
                this.dialogAddProduct = true
            }
        },
        getProductName(key){
            if(key){
                let product = _.find(this.listProduct, (p) => {
                    return p.aliasName == key
                })
                if(product){
                    this.productAssign = product
                    return product.productName + `(${product.productSKU})`
                }
                return ""
            }
            return ""
        },
        // paste(event, index, field) {
        //     event.preventDefault()
        //     var totalCharacterCount = window.event.clipboardData.getData('Text');// || window.clipboardData.getData('Text');
        //     var strValidChars = "+0123456789";
        //     var strChar;
        //     var FilteredChars = "";
        //     for (var i = 0; i < totalCharacterCount.length; i++) {
        //         strChar = totalCharacterCount.charAt(i);
        //         if (strValidChars.indexOf(strChar) != -1) {
        //             FilteredChars = FilteredChars + strChar;
        //         }
        //     }

        //     this.selectedProductObject.tier[index][field] = FilteredChars
        // },
        paste(event, index, field) {
            event.preventDefault()
            var totalCharacterCount = window.event.clipboardData.getData('Text');// || window.clipboardData.getData('Text');
            var strValidChars = "+0123456789";
            var strChar;
            var FilteredChars = "";
            for (var i = 0; i < totalCharacterCount.length; i++) {
                strChar = totalCharacterCount.charAt(i);
                if (strValidChars.indexOf(strChar) != -1) {
                    FilteredChars = FilteredChars + strChar;
                }
            }
            if (field == 'cbp_disc' || field == 'ui_disc' || field == 'bi_disc') {
				this.selectedProductObject.prefix[index].discount[field.replace('_disc','')].value = FilteredChars
			}
			else if(field == 'cbp' || field == 'ui' || field == 'bi'){
				 let name = field == 'cbp' ? '': `_${field}`
				this.selectedProductObject[`monthly_free_count${name}`]
			}
			else if(field == 'intern'){
				this.selectedProductObject.monthly_free_count_international = FilteredChars
			}
			else if(field == 'service'){
				this.selectedProductObject.product_service.fee = FilteredChars
			}
			else {
                this.selectedProductObject.tier[index][field] = FilteredChars
			}
        },
        pasteN(event, index, field) {
            event.preventDefault()
            var totalCharacterCount = window.event.clipboardData.getData('Text');// || window.clipboardData.getData('Text');
            var strValidChars = "+0123456789";
            var strChar;
            var FilteredChars = "";
            for (var i = 0; i < totalCharacterCount.length; i++) {
                strChar = totalCharacterCount.charAt(i);
                if (strValidChars.indexOf(strChar) != -1) {
                    FilteredChars = FilteredChars + strChar;
                }
            }

            this.selectedProductObject[field] = FilteredChars
        },
        buttonAddTier(){
            if(this.selectedProductObject.tier.length > 0){
                let lastPosition = this.selectedProductObject.tier.length - 1
                let lastTier = this.selectedProductObject.tier[lastPosition]
                if(Number.isInteger(parseInt(lastTier.to))){
                    this.selectedProductObject.tier.push({ from: parseInt(lastTier.to) + 1, to: "-", price: parseInt(lastTier.price) + 1000000 })
                } else{
                    this.$message.warning({
                        message: 'Last row of tier is not valid'
                    })
                }
            } else{
                this.selectedProductObject.tier.push({ from: 1, to: "-", price: 1000000 })
            }
        },
        handleChangePrefix(val){
			let found = null
            let clonePrefix = [...this.selectedProductObject.prefix]
            this.selectedProductObject.allowedPrefix = []
			this.selectedProductObject.prefix = []
			this.discount = false
			if (val.length > 0) {
				val.forEach(el => {
					// el = el.replace('+','')
					found = this.countries.find(element => element.prefixCode == el.prefixCode);
					if (found) {
                        this.selectedProductObject.prefix.push({
                            code_prefix: `+${found.prefixCode}`,
                            price : {
                                cbp : found.price_cbp,
                                bi: found.price_bi,
                                ui: found.price_ui
                            },
                            discount : found.prefixCode == '62' ? { cbp:{type:'', value: 0},ui:{type:'', value: 0},bi:{type:'', value: 0} }: false
                        })
                        this.selectedProductObject.allowedPrefix.push(`+${found.prefixCode}`)


						if (found.prefixCode == '62') {
							this.discount = true
						}
					}
				})
			}


           this.selectedProductObject.prefix = this.selectedProductObject.prefix.map(itm => {
                let findPrefix = clonePrefix.find((item) => item.code_prefix == itm.code_prefix)
                if (findPrefix) {
                    itm = findPrefix
                }

                return itm
            })

            // console.log(this.selectedProductObject.prefix);
            this.dialogFormVisible = false
		},
        handleChangeSelectedProduct(val){
            let selectedProduct = _.find(this.product[this.selectedEditNumber].product, (v) => {
                return v._id == val
            })

            this.hidden = false
            this.marketPrefixLength = [];
            this.marketActive = [];
            if(selectedProduct.markets) {
                selectedProduct.markets.map(item => {
                    if(!item.is_delete) {
                        this.marketActive.push(item);
                        item.prefixs.map(el => {
                            this.marketPrefixLength.push(el.code);
                        })
                    }
                })
            }

            this.selectedProductObject = _.cloneDeep(selectedProduct)
            this.selectedProductType = this.selectedProductObject.type;
            this.editProduct.price = this.selectedProductObject.price;
            this.editProduct.remark = this.selectedProductObject.remark;
            this.fbbmId = this.selectedProductObject.fbbm_id;
            this.catalogId = this.selectedProductObject.catalog_id;
            // console.log(this.selectedProductObject);
            // this.selectedProductObject.reff_note = ""

            if(this.selectedProductObject.type.indexOf('tier') != -1){
                this.newPrice = this.selectedProductObject.price.toString()
            } else{
                this.newPrice = ''
            }

            if(this.selectedProductObject.allowedPrefix){
                this.selectedProductObject.allowed_prefix = this.selectedProductObject.allowedPrefix.join(", ")
            }

            if (this.selectedProductObject.productName == 'Whatsapp Conversation') {
                this.hidden = true
                if(this.selectedProductObject.prefix.length > 0){
                    let found = null
                    let arrayFound = []
                    this.selectedProductObject.allowedPrefix = []

                    this.selectedProductObject.prefix.forEach((el,i) => {
                        this.selectedProductObject.allowedPrefix.push(el.code_prefix)
                        el.code_prefix = el.code_prefix
                        found = this.countries.find(element => `+${element.countryCallingCode}` == el.code_prefix);
                        if (found) {
                            // this.selectedProductObject.prefix[i].discount = found.prefixCode == '62' ? {}: false
                            arrayFound.push(found)
                            if (found.countryCallingCode == '62') {
                                if (el.discount) {
                                    el.discount.cbp.type = el.discount.cbp.type ? el.discount.cbp.type:'currency'
                                    el.discount.bi.type = el.discount.bi.type ? el.discount.bi.type:'currency'
                                    el.discount.ui.type = el.discount.ui.type ? el.discount.ui.type:'currency'
                                }
                                this.discount = true
                            }
                        }
                        else {
                            this.selectedProductObject.prefix.splice(i,1)
                            this.selectedProductObject.allowedPrefix.splice(i,1)
                        }
				    })

                    if (arrayFound.length > 0) {
                        this.country = arrayFound.map(el => el.countryNameEn)
                        this.tableData = arrayFound
                        // console.log(arrayFound);
                        // console.log(this.tableData);
                        this.handleSelectionChange(arrayFound)
                        // this.multipleSelection = arrayFound
                    }
                    
                }

                this.isMax.ui = this.selectedProductObject.is_ui_max
                this.isMax.bi = this.selectedProductObject.is_bi_max
                this.handleMax()

                if (this.selectedProductObject["disable_quota_cbp"]) {
                    this.radio_cbp_max = '2'
                }
                else {
                    this.radio_cbp_max = '1'
                }

                if (this.selectedProductObject.hybrid_type && this.selectedProductObject.hybrid_type != '') {
                    if (this.selectedProductObject.hybrid_type == 'bundle_quota') {
                        this.hybrid_type = 1
                    }
                    else if (this.selectedProductObject.hybrid_type == 'plafon_quota') {
                        this.hybrid_type = 2
                    }
                }

                if (this.selectedProductObject.type == 'notification') {
                    this.intern_max = true
                }
                else {
                    this.intern_max = false
                }
            }

            if (this.selectedProductObject.productName == 'Maintenance') {
                this.hidden = true
            }

            if (this.selectedProductObject.type === "wtb_hybrid") {
                this.editProduct.markets = this.selectedProductObject.markets;
                this.marketQuota = this.selectedProductObject.markets;
            }
        },
        async deleteTier(index){
            await this.selectedProductObject.tier.splice(index, 1)
            if(this.selectedProductObject.tier.length > 1){
                let tierLength = this.selectedProductObject.tier.length
                let beforeLastPosition = tierLength - 2
                let beforeLastTier = this.selectedProductObject.tier[beforeLastPosition]
                let lastPosition = tierLength - 1

                this.selectedProductObject.tier[lastPosition].from = parseInt(beforeLastTier.to) + 1
                this.selectedProductObject.tier[lastPosition].to = "-"
            }
        },
        doShowDialogDeleteNumber(key){
            this.dialogDeleteNumber = true
            this.selectedPhoneNumberToDelete = this.product[key].number
        },
        doShowDialogEditNumber(key){
            this.dialogEditNumber = true
            this.selectedPhoneNumberToUpdate = this.product[key].number
        },
        async doDeleteNumber(){
            let custId = this.$route.params.consumen
            this.loadingBtnDelete = true
            await api({
                method: "delete",
                data: {
                    number: this.selectedPhoneNumberToDelete
                },
                url: config.baseApi + 'consumen/' + custId + '/deleteService',
            }).then(res => {
				if(res.data.ec != 200){
					this.$swal(this.$t('error'), this.$t('error_text'), "error").then(this.clear())
				} else {
					this.$swal(this.$t('success'), this.$t('success'), "success").then(this.clear())
                    this.detailConsumenProduct()
                    this.number.length = parseInt(this.number.length) - 1

				}
			}).catch(err => {
                this.$swal(this.$t('error'), this.$t('error_text'), "error").then(this.clear())
                return err
            })
            this.dialogDeleteNumber = false
            this.loadingBtnDelete = false
        },
        doShowDialogEdit(key, phone_number){
            this.clear()
            this.selectedMarketPrefix = [];
            // this.dialogEditChangePrice = true;
            this.listMarketPrefixPhone.map(item => {
                if (item.number === phone_number) {
                    this.selectedMarketPrefix = item.markets
                }
            })
            this.dialogChangePrice = true;
            this.selectedEditNumber = key;
            this.selectedPhoneNumberToUpdate = this.product[key].number
        },
        doShowDialogDelete(key){
            this.dialogDelete = true; 
            this.selectedDeleteNumber = key; 
            this.selectedPhoneNumberToDelete = this.product[key].number
        },
        async doDeleteProduct(){
            if(_.isEmpty(this.selectedProductToDelete)){
                this.$message.error({
                    showClose: false,
                    message: 'All field is required'
                });
                return
            }
            this.loadingBtn = true
            let custId = this.$route.params.consumen
            await api({
                url: config.baseApi + 'consumen/'+custId+'/product/delete',
                method: 'post',
                data: {
                    "phone_number":this.selectedPhoneNumberToDelete,
                    "id":this.selectedProductToDelete
                }
            }).then(res => {
                this.loadingProduct=true
                if(res.data.ec != 200){
                    this.$swal(this.$t('error'), this.$t('error_text'), "error").then(this.clear())
                    this.dialogDelete = false
                } else {
                    this.$swal(this.$t('success'), this.$t('success'), "success").then(this.clear())
                    this.detailConsumenProduct()
                    this.loadingProduct=false
                    this.dialogDelete = false
                }
            }).catch(err => {
                return err
                this.$swal(this.$t('error'), this.$t('error_text'), "error").then(this.clear())
            })
            this.loadingBtn=false
        },
        async saveUpdateProductPrice(){
            if(_.isEmpty(this.selectedPhoneNumberToUpdate) || _.isEmpty(this.selectedProductToUpdate)){
				this.$message.error({
					showClose: false,
					message: 'All field is required'
				});
				return
			}

            if (
                !this.selectedProductObject.fbbm_id && !this.fbbmId &&
                _.isEmpty(this.selectedProductObject.fbbm_id) &&
                this.fbbmId &&
                !this.catalogId
            ){
                this.$message.error({
                    showClose: false,
                    message: 'All field is required'
                });
                return
            }

            let data = {
                    "phone_number":this.selectedPhoneNumberToUpdate,
                    "id":this.selectedProductToUpdate,
                    "count": this.selectedProductObject.count,
                    "price": parseFloat(this.selectedProductObject.price) ? this.selectedProductObject.price : 0,
                    "minPrice": parseFloat(this.selectedProductObject.minPrice) ? this.selectedProductObject.minPrice : 0,
                    "serviceType": this.selectedProductObject.type != '' ? this.selectedProductObject.serviceType : undefined,
                    "serviceFee": this.selectedProductObject.type != '' ? parseFloat(this.selectedProductObject.serviceFee) || '' : undefined,
                    "tier": this.selectedProductObject.tier || undefined,
                    monthly_free_count: this.selectedProductObject.type=='notification_caping_plafon' ? parseInt(this.selectedProductObject.monthly_free_count) : 0,
                    allowed_prefix: this.selectedProductObject.allowed_prefix,
                    sheet: this.selectedProductObject.priceSheet || undefined,
                    reff_note: this.selectedProductObject.reff_note
				}

            if (this.selectedProductType==='wtb_hybrid') {
                this.editProduct.id = this.selectedProductObject._id;
                this.editProduct.productName = this.selectedProductObject.productName;
                this.editProduct.phone_number = this.selectedPhoneNumberToUpdate;
                this.editProduct.catalog_id = this.catalogId;
                this.editProduct.fbbm_id = this.fbbmId;
                this.editProduct.price = this.selectedProductObject.price;
                data = this.editProduct;
            }

            if (this.selectedProductObject.productName == 'Whatsapp Conversation' || this.selectedProductObject.productName == 'Maintenance') {
				if(this.selectedProductObject.prefix.length == 0 && this.selectedProductObject.productName == 'Whatsapp Conversation'){
					this.$message.error({
						showClose: false,
						message: 'All field is required. Prefix code must be selected!'
					});
					this.loadingBtn = false
					return
				}

                if (this.selectedProductObject.prefix.length > 0) {
                    // console.log(this.selectedProductObject.prefix);
                    this.selectedProductObject.prefix.forEach(el => {
                        el.code_prefix = el.code_prefix.includes("+") ? el.code_prefix:`+${el.code_prefix}`
                        if (el.discount) {
                            el.discount.cbp.value = Number(el.discount.cbp.value) || 0
                            el.discount.ui.value = Number(el.discount.ui.value) || 0
                            el.discount.bi.value = Number(el.discount.bi.value) || 0
                        }
                        
                    })
                }

				this.selectedProductObject["monthly_free_count"] = parseInt(this.selectedProductObject.monthly_free_count)|| 0
				this.selectedProductObject["monthly_free_count_ui"] = parseInt(this.selectedProductObject.monthly_free_count_ui) || 0
				this.selectedProductObject["monthly_free_count_bi"] = parseInt(this.selectedProductObject.monthly_free_count_bi) || 0
				this.selectedProductObject["monthly_free_count_international"] = parseInt(this.selectedProductObject.monthly_free_count_international) || 0
				

                // this.selectedProductObject.count = this.selectedProductObject.count.toString() || 'MAX'
                // this.selectedProductObject.count_ui = this.selectedProductObject.count_ui.toString() || 'MAX'
                // this.selectedProductObject.count_bi = this.selectedProductObject.count_bi.toString() || 'MAX'
                // this.selectedProductObject.count_international = this.selectedProductObject.count_international.toString() || '0'

                if (this.selectedProductObject.type == 'notification_caping_plafon') {

                   switch (this.radio_cbp_max) {
                       case '1':
                           this.selectedProductObject.disable_quota_cbp = false
                           break;
                        case '2':
                           this.selectedProductObject.disable_quota_cbp = true
                           break;

                   }

                    this.selectedProductObject.cbp_bundle = this.selectedProductObject.cbp_bundle && !isNaN(this.selectedProductObject.cbp_bundle) ? parseInt(this.selectedProductObject.cbp_bundle) : 0
                    this.selectedProductObject.ui_bundle = this.selectedProductObject.ui_bundle && !isNaN(this.selectedProductObject.ui_bundle) ? parseInt(this.selectedProductObject.ui_bundle) : 0
                    this.selectedProductObject.bi_bundle = this.selectedProductObject.bi_bundle && !isNaN(this.selectedProductObject.bi_bundle) ? parseInt(this.selectedProductObject.bi_bundle) : 0

                    switch (this.hybrid_type) {
						case 1:
							this.selectedProductObject.hybrid_type = 'bundle_quota'

                            if (this.selectedProductObject.cbp_bundle > this.selectedProductObject.monthly_free_count) {
                                this.$message.error({
                                    showClose: false,
                                    message: "Bundle Quota can't be more than Limit Quota per Month!"
                                });
                                this.loadingBtn = false
                                return
                            }

                            if (!this.selectedProductObject.is_ui_max && this.selectedProductObject.ui_bundle > this.selectedProductObject.monthly_free_count_ui) {
                                this.$message.error({
                                    showClose: false,
                                    message: "Bundle Quota can't be more than Limit Quota per Month!"
                                });
                                this.loadingBtn = false
                                return
                            }

                            if (!this.selectedProductObject.is_bi_max && this.selectedProductObject.bi_bundle > this.selectedProductObject.monthly_free_count_bi) {
                                this.$message.error({
                                    showClose: false,
                                    message: "Bundle Quota can't be more than Limit Quota per Month!"
                                });
                                this.loadingBtn = false
                                return
                            }

							break;
					
						case 2:
							this.selectedProductObject.hybrid_type = 'plafon_quota'
                            this.selectedProductObject.cbp_bundle = 0
                            this.selectedProductObject.bi_bundle = 0
                            this.selectedProductObject.ui_bundle = 0
							break;
					}
                }
                else {
                    delete this.selectedProductObject.cbp_bundle
                    delete this.selectedProductObject.ui_bundle
                    delete this.selectedProductObject.bi_bundle
                }

                data = {...this.selectedProductObject, ...data}
			}

            let custId = this.$route.params.consumen
            let apiOptions = {
            	url: config.baseApi + 'consumen/'+custId+'/product',
            	method: 'patch',
            	data: data
            }

            if (this.selectedProductType==='wtb_hybrid') {
                apiOptions = {
                    url: config.baseApi + 'master-consumen/'+custId+'/product',
                    method: 'patch',
                    data: data
                }
            }

            this.loadingBtn = true
			await api(apiOptions).then(res => {
                this.loadingProduct=true
				if(res.data.ec != 200){
					this.$swal(this.$t('error'), this.$t('error_text'), "error").then(this.clear())
                    this.dialogChangePrice=false;
				} else {
					this.$swal(this.$t('success'), this.$t('success'), "success").then(this.clear())
                    this.detailConsumenProduct()
                    this.loadingProduct=false
                    this.dialogChangePrice=false;
                    this.selectedProductObject  = { type: "", tier: [], reff_note: "" }
				}
			}).catch(err => {
                this.$swal(this.$t('error'), this.$t('error_text'), "error").then(this.clear())
            })
            this.loadingBtn=false
        },
        formatPrice(value) {
            // let val = (value/1).toFixed(2).replace('.', ',')
            if(typeof value == "string") value = parseFloat(value)

            if(value == null || value == "") return "-"
			return value.toLocaleString('id-ID', { style: 'currency', currency: 'IDR', minimumFractionDigits: Number.isInteger(value) ? 0 : 4 })
		},
        capitalizeFirstLetter(string) {
			if(string == null || string == ""){
				return "-"
			} else {
                if (string instanceof Object) {
                    let result = ''
                    switch (string.type) {
                        case 'notification':
                            result = "CBP Invoice"
                            break;
                        case 'notification_caping':
                            result = "CBP Caping"
                            break;
                        case 'notification_caping_plafon':
                            result = "CBP Hybrid"
                            break;
                    }

                    return result
                }
                else {
                if(string.split("_").length > 0){
                    let title = []
                    _.map(string.split("_"), (str) => {
                        title.push(str.charAt(0).toUpperCase() + str.slice(1))
                    })
                    return title.join(" ")
                } else {
                    return string.charAt(0).toUpperCase() + string.substring(1);
                }

                }
			}
        },
        async loadWA() {
            this.loadingNumber = true
			let custId = this.$route.params.consumen
			await api({
				method: 'post',
				url: config.baseApi +'user/'+custId+'/detail_number'
			}).then(result => {
                this.number = result.data.data
			}).catch(error => {
				this.showAlertError = true
			})
            this.loadingNumber = false
    	},
        detailConsumenProduct(){
            this.loadingConsumenProduct = true
            let custId = this.$route.params.consumen
            api({
                url: config.baseApi + 'consumen/' + custId + "/product",
                method: 'get'
            })
            .then(res => {
                if(res.data.data.length > 0) this.product = res.data.data
                else this.product = [ { product: [] } ]
                // console.log('Products : ', this.product)
            })
            .catch(err => {
                console.log('Error: ', err);
                return err
            })
            this.loadingConsumenProduct = false
        },
        async listMarketArea(){
            let custId = this.$route.params.consumen
            api({
                url: config.baseApi + 'master-consumen/' + custId + "/product-market-area",
                method: 'get'
            })
            .then(res => {
                var data =
                    res &&
                    res.data &&
                    res.data.data
                        ? res.data.data
                        : '';
                let tempMarket = [];

                data.map(el => {
                    if (el.markets && el.markets.length > 0) {
                        el.markets.map(el2 => {
                            tempMarket.push(el2);
                        })
                    }
                })

                var tempData = [];
                var listPrefix = [];
                tempMarket.map((item, idx) => {
                    let dataMaster = {
                        market_name: item.master_market_area_code,
                        master_market_area_id: item.master_market_area_id,
                        master_market_area_name: item.master_market_area_name,
                        prefix: item.prefixs
                    }

                    // delete duplicate prefix code
                    dataMaster.prefix = dataMaster.prefix.filter((value, index, self) =>
                        index === self.findIndex((t) => (
                            t.code === value.code && !t.code.code
                        ))
                    )

                    let dataPrefix = this.listPrefixCodes.filter(item2 => {
                        return item2.master_market_id === item.master_market_area_id
                    })

                    let codeArr = [];
                    dataMaster.prefix.map(item => {
                        let code = item.code;
                        codeArr.push(code);
                    })
                    dataMaster.prefix = codeArr

                    if (dataPrefix.length > 0) {
                        listPrefix.push(dataPrefix[0]);
                    }
                    tempData.push(dataMaster);
                })
                let dataMasterDefault = {
                    market_name: '',
                    master_market_area_id: '',
                    master_market_area_name: '',
                    prefix: []
                }
                if (tempData.length === 0) {
                    tempData.push(dataMasterDefault);
                }

                this.selectedMarketPrefix = tempData;
                this.listMarketPrefixPhone = data;
                this.listMarketPrefixs = listPrefix;
            })
            .catch(err => {
                this.$swal(this.$t('error'), this.$t('error_text'), "error").then(this.clear())
                return err
            })
        },
        addServiceUser(){
            if(_.isEmpty(this.form.token_whatsapp) || _.isEmpty(this.form.phone_wa)){
				this.$message.error({
					showClose: false,
					message: 'All field is required'
				});
				return
			}
            let custId = this.$route.params.consumen
			api({
				method:'post',
				url:config.baseApi+'consumen/'+custId+'/addServiceUser',
				data:{
					"token_whatsapp":this.form.token_whatsapp,
					"wa_phone":this.form.phone_wa
				}
			}).then(res => {
				if(res.data.ec != 200){
					this.$swal(this.$t('error'), this.$t('error_text'), "error").then(this.clear())
				} else {
					this.$swal(this.$t('success'), this.$t('success'), "success").then(this.clear())
					this.detailConsumenProduct()
				}
			}).catch(err => {
                return err
                this.$swal(this.$t('error'), this.$t('error_text'), "error").then(this.clear())
			})
			this.dialogAddServiceUser=false
        },
        async addProductUser(){
            if(_.isEmpty(this.selectedProductAssigned) || _.isEmpty(this.selectedPhoneNumber)){
                this.$message.error({
                    showClose: false,
                    message: 'All field is required'
                });
                return
            }
            this.loadingBtn = true
            let custId = this.$route.params.consumen
			await api({
				method:'post',
				url:config.baseApi+'master-consumen/'+custId+'/addProductUser',
				data:{
					"product": this.selectedProductAssigned,
                    "phone_number":this.selectedPhoneNumber,
                    allowed_prefix: this.formAddProduct.allowed_prefix
				}
			}).then(res => {
				if(res.data.ec != 200 && res.data.message == "assigned_product"){
					this.$swal(this.$t('error'), "Product already assigned to this number", "error").then()
                } else {
                    this.dialogAddProduct = false
					this.$swal(this.$t('success'), this.$t('success'), "success").then(this.clear())
					this.detailConsumenProduct()
				}
			}).catch(err => {
                this.$swal(this.$t('error'), this.$t('error_text'), "error").then()
			})
            this.loadingBtn = false
        },

        async doUpdatePhoneNumber(){
            if(_.isEmpty(this.newPhoneNumber)){
                this.$message.error({
                    showClose: false,
                    message: 'New phone number is required'
                });
                return
            }
            this.loadingBtn = true
            this.loadingConsumenProduct = true
            
            let custId = this.$route.params.consumen
            await api({
                url: config.baseApi + 'consumen/'+custId+'/update_consumen_number',
                method: 'patch',
                data: {
                    "oldPhoneNumber":this.selectedPhoneNumberToUpdate,
                    "newPhoneNumber":this.newPhoneNumber
                }
            }).then(res => {
                this.loadingConsumenProduct=true
                if(res.data.ec != 200){
                    this.$swal(this.$t('error'), this.$t('error_text'), "error").then(this.clear())
                    this.dialogEditNumber = false
                } else {
                    this.$swal(this.$t('success'), this.$t('success'), "success").then(this.clear())
                    this.dialogEditNumber = false
                    this.detailConsumenProduct()
                }
            }).catch(err => {
                return err
            })
            this.loadingConsumenProduct = false
            this.loadingBtn=false
        },
        async getCountryCode() {
            this.countries = CountryCodes.all();
        },

        clear(){
			this.form.token_whatsapp = ''
			this.form.phone_wa = ''
			this.selectedProductAssigned = ''
            this.selectedPhoneNumber = ''
            this.selectedProductName = ''
            this.selectedProductType = ''
            this.selectedPhoneNumberToUpdate = ''
            this.selectedProductToUpdate = ''
            this.newPrice = ''
            this.selectedProductToDelete = ''
            this.selectedPhoneNumberToDelete = ''
            this.newPhoneNumber = ''
            this.selectedProductObject = {
                fbbm_id: "",
                type: "",
                reff_note: "",
                tier: []
            }
            this.hidden = false
            this.discount = false
            this.isDisabled = true

            this.editProduct = {
                remark: '',
                price: 0,
                productName: '',
                phone_number: '',
                id: ''
            }
        },

        async Prefix(page=1){
			this.loadingProduct = true
            await api({
                url: config.baseApi + "prefix?page="+page +`&all=${true}`,
                method: 'get'
            })
            .then(res => {
				if(res.data.ec != 200){
					this.$swal(this.$t('error'), this.$t('error_text'), "error")
				}
				else {
					this.countries = res.data.data.prefix
					this.totalCountries = res.data.data.total

                    if (this.countries.length > 0) {
                        this.countries = this.countries.filter(el => el.status == 'true')
                    }
				}
            })
            .catch(err => {

            })
            this.loadingProduct = false
            
		},
        async getArea(){
            await api({
                method: 'get',
                url:config.baseApi+'master-market-area'
            }).then(result => {
                var data =
                    result &&
                    result.data &&
                    result.data.data &&
                    result.data.data.rows
                        ? result.data.data.rows
                        : [];
                var status =
                    result &&
                    result.data &&
                    result.data.ec
                        ? result.data.ec
                        : null;
                if(status === 200) {
                    this.listMarkets = data;
                    data.map(item => {
                        let data = {
                            master_market_id: item.id,
                            listPrefix: item.master_prefixs
                        }
                        this.listPrefixCodes.push(data);
                    })
                }
            }).catch(error => {
                console.error("Failed : " + error);
            })
	    },
        validate(type) {
            let status = false;
            if (type === 'market') {
                let data =
                    this.selectedMarketPrefix
                        ? this.selectedMarketPrefix
                        : [];
                data.map(item => {
                    if (!item.master_market_area_id) {
                        status = true;
                    } else if (item.prefixs.length === 0) {
                        status = true;
                    }
                })
            }
            return status;
        }
    },
    async mounted(){
        // this.loadWA()
        await this.Prefix()
        await this.detailConsumenProduct()
        await this.getListMarket();
        await this.getCountryCode();
        await this.getArea();
        await this.listMarketArea();
    },
    watch: {
        listProductUser: function(){
            // console.log(this.listProduct.length)
            if(this.listProductUser.length > 0) this.product = this.listProductUser
        },
        loadingPage: function(){
            this.loadingConsumenProduct = this.loadingPage
            this.number = this.waUserDetail.sender
        }
    }
}
</script>

<style lang="scss">

.el-checkbox {
    .el-checkbox__label {
        color: #249393;
    }
}
</style>

<style lang="scss" scoped>
.img-center {
    display: block;
    margin-bottom: 60px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 60px;
    width: 10%;
}
</style>